module.exports = __webpack_public_path__ + "assets/img/video22.4dcd3673.png";